/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import {
  getCheckPay,
  getDisputeSpecialists,
  getLetterSenders,
  getOverrideDefaultData,
  getOverrideSystemData,
  getDropdownByCode,
} from './store/actions';
import * as Messages from './RebatePgmConstants';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import NumberFormatCustom from '../../../SharedModules/NumberFormat/NumberFormat';

const DefaultOverrideTab = (props) => {
  const { changeHandler, blurHandler, flderr, details, isEnablebyRole } = props;
  const [disableSysDef, setDisableSysDef] = React.useState(false);
  const [specialists, setSpecialists] = React.useState([]);
  const [letter_sender, setLetterSender] = React.useState([]);
  const [detail_lvl, setDetailLvl] = React.useState([]);
  const dispatch = useDispatch();
  const getDropdownData = async () => {
    let list = await dispatch(getDisputeSpecialists());
    setSpecialists(list);
    list = await dispatch(getLetterSenders());
    setLetterSender(list);
    list = await dispatch(getDropdownByCode(['DETAIL_LEVEL_ON_INVOICE_CD']));
    setDetailLvl(
      list?.DETAIL_LEVEL_ON_INVOICE_CD ? list.DETAIL_LEVEL_ON_INVOICE_CD : []
    );
  };

  React.useEffect(() => {
    // if (!detail_lvl) dispatch(getCheckPay('DETAIL_LEVEL_ON_INVOICE_CD'));
    // if (!letter_sender) dispatch(getLetterSenders());
    // if (!specialists) dispatch(getDisputeSpecialists());
    getDropdownData();
  }, []);

  React.useEffect(() => {
    if (details && details.useDefSystemInd === 1) setDisableSysDef(true);
    else setDisableSysDef(false);
  }, [details]);

  return (
    <div className=''>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='mui-custom-form frr-mui-custom-form input-sm frr-custom-font-12m600'>
            <FormControlLabel
              className='frr-ml-minus22'
              control={<Checkbox color='primary' />}
              label='Use System Defaults'
              value={details?.useDefSystemInd === 1}
              onChange={(e, val) => changeHandler(val, 'useDefSystemInd', true)}
              checked={details?.useDefSystemInd === 1}
              data-testid='useDefSystemInd'
              disabled={!isEnablebyRole}
            />
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-xl-8'>
          <fieldset
            className='custom-fieldset mt-3'
            data-testid='overridesystemdefault'
            style={{ height: 'auto' }}
          >
            <legend className='same-font-family'>
              Override System Default
            </legend>
            <div className='form-wrapper form-wrapper-col-2 frr-min-width-304'>
              <div className='mui-custom-form'>
                <div className='input-md mandate-fields'>
                  <TextField
                    id='invoiceMailThreshold'
                    className='mb-3'
                    data-testid='useDefSysinvoiceMailThreshold'
                    label='Invoice Mail Threshold'
                    value={details?.invoiceMailThreshold || ''}
                    inputProps={{
                      maxLength: 14,
                      id: 'invoiceMailThreshold',
                    }}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                      startAdornment: (
                        <InputAdornment className='prefix-symbol'>
                          $
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'invoiceMailThreshold')
                    }
                    onBlur={(e) =>
                      blurHandler(e.target.value, 'invoiceMailThreshold')
                    }
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      flderr?.invoiceMailThresholdErr
                        ? Messages.INVOICE_MAIL_ERR
                        : null
                    }
                    error={flderr?.invoiceMailThresholdErr}
                    disabled={disableSysDef || !isEnablebyRole}
                  />
                </div>
                <div className='input-md mandate-fields frr-text-feild-wrap'>
                  <TextField
                    id='reimbursementUnderThresholdMultiple'
                    className='mb-3 frr-label-width-350'
                    disabled={disableSysDef || !isEnablebyRole}
                    data-testid='useDefSysreimbUnderThresholdMult'
                    label='Reimbursement Under Threshold Multiplier'
                    value={details?.reimbUnderThresholdMult || ''}
                    inputProps={{
                      maxLength: 3,
                      id: 'reimbursementUnderThresholdMultiple',
                    }}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'reimbUnderThresholdMult')
                    }
                    // onBlur={(e) => blurHandler(e.target.value, 'shortDescr')}
                    InputLabelProps={{ shrink: true }}
                    // helperText={
                    //   flderr?.shtDescErr ? Messages.SHORT_DESC_ERR : null
                    // }
                    // error={flderr?.shtDescErr}
                  />
                </div>
                <div className='input-md mandate-fields frr-custom-font-12m600'>
                  <FormControlLabel
                    className='ml-0'
                    control={<Checkbox color='primary' />}
                    disabled={disableSysDef || !isEnablebyRole}
                    label='Show Dispute on Invoice'
                    value={details?.showDisputeOnInvInd === 1}
                    onChange={(e, val) =>
                      changeHandler(val, 'showDisputeOnInvInd', true)
                    }
                    checked={details?.showDisputeOnInvInd === 1}
                    data-testid='showDisputeOnInvInd'
                  />
                </div>
                <div className='input-md mandate-fields frr-custom-font-12m600'>
                  <FormControlLabel
                    className='ml-0'
                    control={<Checkbox color='primary' />}
                    disabled={disableSysDef || !isEnablebyRole}
                    label='Unit Conversion Changes Data'
                    value={details?.unitConvChangesDataInd === 1}
                    onChange={(e, val) =>
                      changeHandler(val, 'unitConvChangesDataInd', true)
                    }
                    checked={details?.unitConvChangesDataInd === 1}
                    data-testid='unitConvChangesDataInd'
                  />
                </div>
              </div>
              <div className='mui-custom-form'>
                <div className='input-md mandate-field frr-custom-font-12m600'>
                  <FormControlLabel
                    className='ml-0 mt-4'
                    control={<Checkbox color='primary' />}
                    label='Auto Under Threshold'
                    value={details?.autoUnderThresholdInd === 1}
                    onChange={(e, val) =>
                      changeHandler(val, 'autoUnderThresholdInd', true)
                    }
                    checked={details?.autoUnderThresholdInd === 1}
                    data-testid='autoUnderThresholdInd'
                    disabled={disableSysDef || !isEnablebyRole}
                  />
                </div>
                <div className='input-md mandate-fields'>
                  <TextField
                    id='sendAllRetainedQuarter'
                    className='mb-3 frr-mt-20'
                    // id="descsrt"
                    label='Send all Retained Quarter'
                    data-testid='sendAllRetainedQtrtest'
                    value={details?.sendAllRetainedQtr || ''}
                    inputProps={{ maxLength: 1, id: 'sendAllRetainedQuarter' }}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'sendAllRetainedQtr')
                    }
                    InputLabelProps={{ shrink: true }}
                    onBlur={(e) =>
                      blurHandler(e.target.value, 'sendAllRetainedQtr')
                    }
                    helperText={
                      flderr?.sendAllRetainedQtrErr
                        ? Messages.SEND_ALL_RETAINED_QTR
                        : null
                    }
                    error={flderr?.sendAllRetainedQtrErr}
                    disabled={disableSysDef || !isEnablebyRole}
                  />
                </div>
                <div className='input-md mandate-fields frr-custom-font-12m600'>
                  <FormControlLabel
                    className='ml-0'
                    control={<Checkbox color='primary' />}
                    label='Forgive Requires Comment'
                    value={details?.forgiveReqCommentInd === 1}
                    onChange={(e, val) =>
                      changeHandler(val, 'forgiveReqCommentInd', true)
                    }
                    checked={details?.forgiveReqCommentInd === 1}
                    data-testid='forgiveReqCommentInd'
                    disabled={disableSysDef || !isEnablebyRole}
                  />
                </div>
                <div className='input-md mandate-fields frr-custom-font-12m600'>
                  <FormControlLabel
                    className='ml-0'
                    control={<Checkbox color='primary' />}
                    label='Permit Non-Zero Billed Units'
                    value={details?.nonZeroBilledUnitsInd === 1}
                    onChange={(e, val) =>
                      changeHandler(val, 'nonZeroBilledUnitsInd', true)
                    }
                    checked={details?.nonZeroBilledUnitsInd === 1}
                    data-testid='nonZeroBilledUnitsInd'
                    disabled={disableSysDef || !isEnablebyRole}
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div className='col-sm-12 col-xl-4'>
          <fieldset
            className='custom-fieldset mt-3'
            data-testid='rebateprogramdefault'
            style={{ height: 'auto' }}
          >
            <legend
              className='same-font-family'
              style={{ marginRight: '-3px' }}
            >
              Rebate Program Defaults Section
            </legend>
            <div className='form-wrapper form-wrapper-col-1'>
              <div className='mui-custom-form frr-mui-custom-form-new'>
                <div
                  className='input-md mandate-fields'
                  style={{ width: '80%' }}
                >
                  <TextField
                    id='earliestQuarterForDrugDetails'
                    className='mb-3'
                    label='Earliest Quarter for Drug Details'
                    data-testid='defEarliestQtrForDrugDtlstest'
                    required
                    value={details?.defEarliestQtrForDrugDtls || ''}
                    inputProps={{
                      maxLength: 6,
                      id: 'earliestQuarterForDrugDetails',
                    }}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'defEarliestQtrForDrugDtls')
                    }
                    onBlur={(e) =>
                      blurHandler(e.target.value, 'defEarliestQtrForDrugDtls')
                    }
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      flderr?.earlierQtrReqErr
                        ? Messages.EARLIER_QTR_ERR
                        : flderr?.earlierQtrQtrErr
                        ? constantMessageData.VALIDATE_QUARTER_VALUE
                        : null
                    }
                    error={flderr?.earlierQtrReqErr || flderr?.earlierQtrQtrErr}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div
                  className='input-md mandate-fields'
                  style={{ width: '80%' }}
                >
                  <TextField
                    id='detailLevelOnInvoice'
                    className='mb-3'
                    // id="descsrt"
                    label='Detail Level on Invoice'
                    data-testid='defDetailLevelOnInvoiceCdtest'
                    value={details?.defDetailLevelOnInvoiceCd || '-1'}
                    inputProps={{ maxLength: 30, id: 'detailLevelOnInvoice' }}
                    select
                    onChange={(e) =>
                      changeHandler(e.target.value, 'defDetailLevelOnInvoiceCd')
                    }
                    // onBlur={(e) => blurHandler(e.target.value, 'shortDescr')}
                    InputLabelProps={{ shrink: true }}
                    disabled={!isEnablebyRole}
                    // helperText={
                    //   flderr?.shtDescErr ? Messages.SHORT_DESC_ERR : null
                    // }
                    // error={flderr?.shtDescErr}
                  >
                    <MenuItem
                      className='frr-dropdown-blank-item'
                      key=''
                      value='-1'
                    />
                    {detail_lvl &&
                      detail_lvl
                        ?.filter((x) => {
                          if (details?.planTypeCd !== 'SUPP') {
                            return x.codeValueID.codeValue !== 'DF';
                          }
                          return x;
                        })
                        ?.map((item, ind) => (
                          <MenuItem
                            key={ind}
                            value={item.codeValueID.codeValue}
                          >
                            {item.codeValueID.codeValue}:{' '}
                            {item.shortDescription}
                          </MenuItem>
                        ))}
                  </TextField>
                </div>
                <div
                  className='input-md mandate-fields'
                  style={{ width: '80%' }}
                >
                  <TextField
                    id='disputeSpecialist'
                    className='mb-3'
                    // id="descsrt"
                    label='Dispute Specialist'
                    value={details?.progDefDispSpecialist || '-1'}
                    inputProps={{ maxLength: 30, id: 'disputeSpecialist' }}
                    select
                    data-testid='progDefDispSpecialisttest'
                    onChange={(e) =>
                      changeHandler(e.target.value, 'progDefDispSpecialist')
                    }
                    // onBlur={(e) => blurHandler(e.target.value, 'shortDescr')}
                    InputLabelProps={{ shrink: true }}
                    disabled={!isEnablebyRole}
                    // helperText={
                    //   flderr?.shtDescErr ? Messages.SHORT_DESC_ERR : null
                    // }
                    // error={flderr?.shtDescErr}
                  >
                    <MenuItem
                      className='frr-dropdown-blank-item'
                      key=''
                      value='-1'
                    />
                    {specialists &&
                      specialists.map((item, ind) => (
                        <MenuItem key={ind} value={item.userId}>
                          {item.userId} - {item.lastName}, {item.firstName}
                        </MenuItem>
                      ))}
                  </TextField>
                </div>
                <div
                  className='input-md mandate-fields'
                  style={{ width: '80%' }}
                >
                  <TextField
                    id='letterSender'
                    className='mb-3'
                    // id="descsrt"
                    label='Letter Sender'
                    value={details?.defLetterSenderUserId || '-1'}
                    inputProps={{ maxLength: 30, id: 'letterSender' }}
                    select
                    onChange={(e) =>
                      changeHandler(e.target.value, 'defLetterSenderUserId')
                    }
                    // onBlur={(e) => blurHandler(e.target.value, 'shortDescr')}
                    InputLabelProps={{ shrink: true }}
                    disabled={!isEnablebyRole}
                    // helperText={
                    //   flderr?.shtDescErr ? Messages.SHORT_DESC_ERR : null
                    // }
                    // error={flderr?.shtDescErr}
                  >
                    <MenuItem
                      className='frr-dropdown-blank-item'
                      key=''
                      value='-1'
                    />
                    {letter_sender &&
                      letter_sender.map((item, ind) => (
                        <MenuItem key={ind} value={item.userId}>
                          {item.userId} - {item.lastName}, {item.firstName}
                        </MenuItem>
                      ))}
                  </TextField>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
};
export default DefaultOverrideTab;
